import React from 'react';
import DataTable, { createTheme } from 'react-data-table-component';

createTheme('teambuildr', {
  text: {
    primary: '#444444',
    secondary: '#898989',
  },
  background: {
    default: 'transparent',
  },
});

/**
 * Exported so BoardTable (leaderboard's TV Mode) can scale table styling
 * without adding scaleFactor to this component's own props. Must return a
 * fresh object per call — a single shared object would leak one consumer's
 * scale into another's render.
 * @param {number} scaleFactor
 */
export const buildTeambuildrStyles = (scaleFactor = 1) => ({
  headRow: {
    style: {
      padding: `${Math.round(20 * scaleFactor)}px ${Math.round(10 * scaleFactor)}px`,
      border: 'none',
      pageBreakAfter: 'avoid',
      pageBreakBefore: 'avoid',
    },
  },
  headCells: {
    style: {
      fontFamily: 'Nunito Sans',
      fontSize: `${Math.round(12 * scaleFactor)}px`,
      fontWeight: '900',
      textTransform: 'uppercase',
      letterSpacing: '1.29px',
      textAlign: 'center',
    },
  },
  cells: {
    style: {
      padding: `${Math.round(20 * scaleFactor)}px ${Math.round(18 * scaleFactor)}px`,
      fontFamily: 'Nunito Sans',
      fontSize: `${Math.round(12 * scaleFactor)}px`,
      fontWeight: '800',
    },
  },
  rows: {
    style: {
      background: 'white',
      marginBottom: `${Math.round(10 * scaleFactor)}px`,
      borderBottomWidth: '0px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.1)',
      pageBreakInside: 'avoid',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#f9f9f9',
      borderBottomColor: '#f9f9f9',
    },
  },
});

/**
 * Adds additional styles to table from the component that is rendering it
 * @param {*} options Dictionary of options
 */
const generateStyle = (options) => {
  const styles = buildTeambuildrStyles();
  if (options.headCells && options.headCells.textAlign) {
    styles.headCells.style.textAlign = options.headCells.textAlign;
  }
  if (options.props && options.props.fitContainer) {
    styles.tableWrapper = {
      style: {
        display: 'block',
      },
    };
  }
  return styles;
};

const Table = ({
  ...props
}) => {
  const options = { props };

  return (
    <DataTable
      {...props}
      customStyles={generateStyle(options)}
      theme='teambuildr'
    />
  );
};

export default Table;
